import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar";
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";

export default React.createClass({
  displayName: "zoom-sdk-size-and-app-thinning",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },
  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },


  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container webservice-documentation">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="zoom-sdk-size-and-app-thinning-educational-resources">FaceTec SDK Size & App Thinning Educational Resources</h2>
                </div>
                <p>Library size is a poorly understood topic.  Bitcode, universal binaries, release mode optimization, app thinning, and compression don't make it any easier.  This guide discusses the topic of SDK Size and demonstrates how you can check the size yourself!</p>
                <hr/>
              </section>


              <section>
                <h3 id="introduction">Introduction</h3>
                <p>Here at FaceTec, we provide Device SDKs that integrate quickly and with minimal coding required into your Browser, Mobile Browser, iOS, or Android Apps.  The FaceTec Device SDKs ship with a real-time image processing, computer vision, and machine learning pipeline, as well as machine learning models that do quality, security, and pre-Liveness checks.</p>
                <p>Machine learning models tend to be large, but we have worked diligently to reduce the space required for the FaceTec SDK by App thinning, package size and binary size reduction.  Rest assured that the Device SDKs contains the bare necessities to do its job, and everything else resides on the far more resource-rich Server.</p>
                <p>To be very clear, if you learn nothing else from this document, no matter what you think you see on an App store listing for a Demo App, or in a FaceTec Sample App, please remember:</p>
                <p><strong>FaceTec Device SDKs add <span style={{color:'blue'}}>~6.5MB</span> to iOS/Android Apps & <span style={{color:'blue'}}>~3MB</span> to Webpages</strong> (both compressed).</p>
                <p></p>
                <p></p>
              </section>

              <section>
                <h3 id="demo">Demo</h3>
                <p>Here is a video that demonstrates the full process of verifying for yourself that an app that includes the FaceTec Device SDK adds ~7MB to your app: <a href="https://www.youtube.com/watch?v=PbySY9QbiXM&feature=youtu.be" target="_blank">View Video.</a></p>
                <p>This video shows you how to perform the entire process of distributing a thinned-for-arm64 iOS app:</p>
                <ul>
                  <li><p>Downloading the FaceTec Device SDK (iOS) from scratch.</p></li>
                  <li><p>Archiving the Complete Sample App.</p></li>
                  <li><p>During App Thinning, choosing an arm64 device.</p></li>
                  <li><p>Building an IPA file.</p></li>
                  <li><p>Unzipping the IPA file and navigating to the primary FaceTec resource container.</p></li>
                  <li><p>Zipping this resource by itself and verifying the size.</p></li>
                </ul>
                <p>Please note: If you don’t perform thinning as in the above example you will generate a <strong>"fat"</strong> (also called universal) app/package that will include the binaries and resources for both armv7 and arm64.</p>
                <p></p>
                <p></p>
              </section>

              <section>
                <h3 id="what-is-app-thinning">What is App Thinning (iOS/Android)?</h3>
                <p>iOS and Android have various ways of conveying a very similar concept.  On both architectures, we define the concept of App Thinning as: "Creating and distributing your application so that your users only download the bytes they need over the wire, not bytes for an architecture that any given User’s phone does not support and does not use."</p>
                <p><strong>Architectures</strong></p>
                <p>There are 3 primary architectures:</p>
                <ul>
                  <li>armv7 -- Old iPhones and Old Android devices.</li>
                  <li>arm64 -- All new iPhones and most new Android devices.</li>
                  <li>x86 -- iOS and Android Simulator and an extremely small and dying segment of real Android devices.</li>
                </ul>
                <p>The ~7MB quoted above is the size of the added amount that our binary and resources adds to the App your arm64 users get if you configure your App correctly.  The size is actually less (somewhere around 4MB) for armv7, as the binaries are inherently smaller.</p>
                <p><strong>Android</strong></p>
                <p>On Android, the concept is actually called "App Bundle".</p>
                <p><a href="https://developer.android.com/guide/app-bundle" target="_blank">https://developer.android.com/guide/app-bundle</a></p>
                <p>"An Android App Bundle is a new upload format that includes all your App’s compiled code and resources, but defers APK generation and signing to Google Play."</p>
                <p>Per the guide above, if you correctly apply App Bundles, your customers will download APKs that Google Play generates that ONLY contain the resources (at the specific resolution for that device) and binaries (specific libraries for that specific phone’s architecture).</p>
                <p></p>
                <p></p>
              </section>

              <section>
                <h3 id="app-configuration-options-that-you-control">App Configuration Options That You Control</h3>
                <p>When customers complain that they can’t add 7MB to their App because it’s already too big we usually go analyze their App and find a lot of bloat...   Reasons for this include:</p>
                <ul>
                  <li>Creating a fat/universal IPA/APK -- You can reduce your size by ~50% if you do proper thinning/bundling.</li>
                  <li>Using Swift -- this incurs 3-12MB to App size simply by using Swift.</li>
                  <li>Image resources -- We frequently see 10-30MB of images in Apps.  Usually these images are in unused flows in the App, or only used once, or are not properly thinned -- and thus are punishing all users in order to give high resolution images to a few.  Please consider:.
                    <ul>
                      <li>Applying App bundling</li>
                      <li>Dynamic resource download where possible instead of carrying around image data in your package.</li>
                      <li>Applying image optimization to get vast reduction in size with hardly noticeable changes to the actual image data itself.</li>
                    </ul>
                  </li>
                </ul>
                <p></p>
                <p></p>
              </section>

              <section>
                <h3 id="faqs">FAQs</h3>

                <p><strong>Q:</strong> "I downloaded your iOS SDK and the size of the .framework file is 100+ MB, does this mean this adds 100+ MB to my App?"</p>
                <p><strong>A:</strong> No, to get the size that FaceTec SDKs will add to your Application you need to build an actual IPA file in release mode and apply proper thinning in order to see the true size.  Please see the video linked above.</p>
                <p></p>
                <p><strong>Q:</strong> "I am seeing that FaceTec's App Store/Google Play demo App is 10, 20, 30, etc. megabytes, does this mean the SDK is that big?"</p>
                <p><strong>A:</strong> Our App Store/Google Play demo App contains extra code and libraries in the container App, image resources, other resources, and may contain a version of FaceTec SDKs that is not exactly in line with our latest released version of FaceTec SDKs.  Although we do ensure our public demos do have a minimum quality bar, it could contain test code or experiments that affect the size.  The only way to prove to yourself that the FaceTec SDK increases your iOS/Android App by 6-7MB (compressed size) is to build your own App with FaceTec integrated and properly thinned.  If you need assistance proving this to yourself and/or ensuring your App is properly thinned, please contact us with the exact steps you are taking to create a release package of your App, and the sizes of the various components you are seeing before and after thinning, and we can help you with this process.</p>
                <p></p>
                <p><strong>Q:</strong> "Can we just use certain components and make the Device SDK increase smaller?"</p>
                <p><strong>A:</strong> "No."</p>
                <p></p>
                <p><strong>Q:</strong> "My App is already 50, 100, 150 (or more!) megabytes and my users will think our App is huge if we add 6-7 more megabytes."</p>
                <p><strong>A:</strong> "Your App is already huge, and probably needs to be optimized.  We are experts in App thinning and have helped many customers with their Apps that are improperly thinned.  Often times, we have found that the amount FaceTec adds less space to a customer’s App than a handful of already-existing, improperly thinned and poorly optimized image resources in the customer App payload.  Your App also may contain Swift.  If you are using Swift, you have already made a conscious choice to make large sacrifices to the size of your Application."</p>
                <p></p>
                <p><strong>Q:</strong> "I perceive 6-7 megabytes (mobile) or 2-3 megabytes (Browser) as still too much, what else can you do?"</p>
                <p><strong>A:</strong> "If you desire to achieve Certified 3D Liveness Detection and Industry Leading 3D Matching performance, all with great speed and UX, we encourage you to go try implementing it yourself!  The truth is, this is an extremely small add to your App for a huge benefit, and the concern over single digit megabytes becomes less of a concern as each day passes because mobile devices offer more storage, cheaper data plans and faster network technology."</p>
              </section>


              <SDKSidebar menuType="main" title="SDK Size & App Thinning Educational Resources"/>


            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/zoom-sdk-size-and-app-thinning.jsx